import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
// import DashboardTables from "./components/dashboard/DashboardTables";
import LatestJobs from "./components/tables/LatestJobs";
import AdmitCards from "./components/tables/AdmitCards";
import Results from "./components/tables/Results";
import AllJobs from "./components/pages/AllJobs";
import AllAdmitCards from "./components/pages/AllAdmitCards";
import AllResults from "./components/pages/AllResults";
import JobDetails from "./components/pages/JobDetails";
import FAQContent from "./components/site-content/FAQContent";
import AdvertiseWithUs from "./components/pages/AdvertiseWithUs";
import BlogHome from "./components/blog/BlogHome";
import BlogPreview from "./components/blog/BlogPreview";

// import TopJobsCard from "./components/pages/TopJobsCard";
// import { BiColor } from "react-icons/bi";




// const MainWrapper = () => {
//   const location = useLocation();

//   const isAllJobsPage = location.pathname === "/all-jobs";

//   return (
//     <div className="page-wrapper">
//   <Header />
//   <main className={isAllJobsPage ? "main-all-jobs" : "main-default"}>
//     <Routes>
//       <Route
//         path="/"
//         element={
//           <>
//             <h2>Welcome to IndianJobs360</h2>
//             <p>Get Online Form, Results, Admit Card, Answer Key, Syllabus, Career News etc.</p>

//             {/* this show the top jobs in boxes based on tag */}
//             {/* <TopJobsCard /> */}
//             <div className="table-row-desktop">
//               <LatestJobs />
//               <AdmitCards />
//               <Results />
//             </div>
//             <FAQContent />
//           </>
//         }
//       />
//       <Route path="/all-jobs" element={<AllJobs />} />
//       <Route path="/all-admit-cards" element={<AllAdmitCards />} />
//       <Route path="/all-results" element={<AllResults />} />
//       {/* <Route path="/job/:id" element={<JobDetails />} /> */}
//       <Route path="/job/:slug" element={<JobDetails />} />
//       <Route path="/advertise-with-us" element={<AdvertiseWithUs />} />
       
//        {/* blog paths */}
//       {/* <Route path="/blogs" element={<BlogHome />} /> */}
//       {/* <Route path="/blogs/:slug" element={<BlogPreview />} /> */}


//       <Route path="/blogs" element={<main className="blog-home-wrapper"><BlogHome /></main>} />
//       <Route path="/blogs/:slug" element={<main className="main-blog"><BlogPreview /></main>} />


      

//     </Routes>
//   </main>
//   <Footer />
// </div>

//   );
// };


const MainWrapper = () => {
  return (
    <div className="page-wrapper">
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <main className="main-default">
              <h2>Welcome to IndianJobs360</h2>
              <p>
                Get Online Form, Results, Admit Card, Answer Key, Syllabus,
                Career News etc.
              </p>

              <div className="table-row-desktop">
                <LatestJobs />
                <AdmitCards />
                <Results />
              </div>
              <FAQContent />
            </main>
          }
        />

        <Route path="/all-jobs" element={<main className="main-all-jobs"><AllJobs /></main>} />
        <Route path="/all-admit-cards" element={<main className="main-default"><AllAdmitCards /></main>} />
        <Route path="/all-results" element={<main className="main-default"><AllResults /></main>} />
        <Route path="/job/:slug" element={<main className="main-default"><JobDetails /></main>} />


        <Route path="/advertise-with-us" element={<main className="main-default"><AdvertiseWithUs /></main>} />
        
        
        {/* blog paths */}
        <Route path="/blogs" element={<main className="blog-home-wrapper"><BlogHome /></main>} />
        <Route path="/blogs/:slug" element={<main className="main-blog"><BlogPreview /></main>} />

      </Routes>
      <Footer />
    </div>
  );
};


function App() {
  return (
    <Router>
      <div className="page-wrapper">
        <MainWrapper />
      </div>
    </Router>
  );
}

export default App;













